import { default as accountTypes } from "@/app/shared/store/account-types/account-types.store";
import { default as config } from "@/app/shared/store/config/config.store";
import { default as marketdata } from "@/app/shared/store/market-data/market-data.store";
import { store as performance } from "@/app/modules/performance/performance.module";
import { store as investment } from "@/app/modules/layout-investment/investment.module";
import { store as marketplace } from "@/app/modules/marketplace/marketplace.module";
import { store as notification } from "@/app/modules/notification/notification.module";
import { store as eventAndNotification } from "@/app/modules/event-and-notification/event-and-notification.module";
import { store as stream } from "@/app/modules/stream/stream.module";
import { store as partners } from "@/app/modules/partners/partners.module";
import { store as payment } from "@/app/modules/payment/payment.module";
import { store as longShort } from "@/app/modules/longshort/longshort.module";
import { store as bests } from "@/app/modules/bests/bests.module";
import { store as tradeIdeas } from "@/app/modules/trade-ideas-v2/trade-ideas.module";

export default {
  eventAndNotification,
  performance,
  accountTypes,
  investment,
  marketplace,
  notification,
  config,
  stream,
  partners,
  payment,
  marketdata,
  longShort,
  bests,
  tradeIdeas,
};
